import { Component, Input, Output, EventEmitter, signal } from '@angular/core';

export interface Tab {
  id: string;
  label: string;
  icon?: string;
}

/**
 * Horizontal tab bar that tracks the active tab via a signal and emits changes to the parent.
 */
@Component({
  selector: 'es-tab-set',
  template: `
    <div>
      <div class="flex border-b border-[var(--border)]">
        @for (tab of tabs; track tab.id) {
          <button
            class="px-4 py-2.5 text-sm font-medium transition-colors cursor-pointer relative"
            [class]="tab.id === activeTab()
              ? 'text-echo-blue'
              : 'text-[var(--text-secondary)] hover:text-[var(--text)]'"
            (click)="selectTab(tab.id)"
          >
            @if (tab.icon) {
              <span class="mr-1.5">{{ tab.icon }}</span>
            }
            {{ tab.label }}
            @if (tab.id === activeTab()) {
              <div class="absolute bottom-0 left-0 right-0 h-0.5 bg-echo-blue"></div>
            }
          </button>
        }
      </div>
      <div class="pt-4">
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class TabSetComponent {
  @Input() tabs: Tab[] = [];
  @Input() defaultTab?: string;
  @Output() tabChanged = new EventEmitter<string>();

  activeTab = signal('');

  ngOnInit() {
    this.activeTab.set(this.defaultTab ?? this.tabs[0]?.id ?? '');
  }

  selectTab(id: string) {
    this.activeTab.set(id);
    this.tabChanged.emit(id);
  }
}
